<template>
    <a href="#" class="btn btn-primary" aria-role="button" v-on:click.prevent="updateSupportFinderSelections" v-if="!loading" :disabled="toggling">
        {{toggling ? 'Saving updates...' : 'Save updates to MyHIE'}}
    </a>
</template>

<script>
    import $ from 'jquery'
    import Axios from 'axios'

    export default {
        created: function () {
            this.init()
        },

        data() {
            return {
                loading: true,
                toggling: false
            }
        },

        methods: {
            init: function () {
                const vm = this
                vm.loading = false
            },

            updateSupportFinderSelections: function () {
                const vm = this
                vm.toggling = true

                const updateProfile = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/UpdateSupportFinderSelections', { params: { organisationSize: vm.organisationSize, organisationTypeSelections: vm.organisationType, regionSelections: vm.regionSelections, supportSelections: vm.supportSelections } })
                }

                Axios.all([updateProfile()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.popup.show()
                        }

                        vm.loading = false
                        vm.toggling = false
                    }))
                    .catch(() => {
                        vm.loading = false
                        vm.toggling = false
                    })
            }
        },

        mounted: function () {
            const vm = this
            vm.init()
            vm.popup = $('.popup')
        },

        props: {
            organisationSize: {
                required: false,
                type: String
            },
            organisationType: {
                required: false,
                type: String
            },
            regionSelections: {
                required: false,
                type: String
            },
            supportSelections: {
                required: false,
                type: String
            }
        },

        watch: {
            organisationSize: function () {
                this.init()
            },
            organisationType: function () {
                this.init()
            },
            regionSelections: function () {
                this.init()
            },
            supportSelections: function () {
                this.init()
            }
        }
    }
</script>
